import {
  select,
  put,
  call,
  fork,
  takeEvery,
  take,
  all,
  takeLatest,
} from 'redux-saga/effects';
import app from '../../app';
import {
  loadCartNumber,
  loadCartList,
  loadCartListCompletion,
  addCart,
  addCartCompletion,
  addXgCartCompletion,
  removeCart,
  removeCartCompletion,
  updateCartItemCompletion,
  loadCartNumberCompletion,
  loadCartShareInfoCompletion,
  loadCartMergeProductListCompletion,
  addCartMergeCompletion,
  loadCartActivityGiftListCompletion,
  pickCartActivityGiftCompletion,
  loadCartExtraInfo,
  loadCartExtraInfoCompletion,
  resetCartExtraInfo,
  setStorageCartSelection,
  addCartDefaultGift,
  addCartDefaultGiftCompletion,
  loadCartManJLevelsCompletion,
} from '../../actions';

export function* watchLoadCartList() {
  yield takeEvery('LOAD_CART_LIST', function*({ needsPreCreate, cartType }) {
    let fetchUrl = '/api/cart/list2';
    let storageKeyPrefix = 'NORMAL_CART_SELECTION';

    if (cartType === 2) {
      fetchUrl = '/api/globalCart/list';
      storageKeyPrefix = 'OVERSEA_CART_SELECTION';
    }

    const options = { url: fetchUrl };
    const result = yield call(app.httpFetch, options);

    if (result.error) {
      yield put(loadCartListCompletion(cartType, result.error));
      return;
    }

    const list = (result.data && result.data.listData) || [];
    const own = yield select(state => state.own.own);

    const storageKey = `${storageKeyPrefix}_${own ? own.uid : ''}`;
    let selection = yield call(app.getStorage, storageKey);

    if (!selection) {
      selection = {};
    }
    selection = list.reduce((sel, { cartVo, product, code }) => {
      if (cartType === 2) {
        if (selection[code] && product.stock > 0 && product.status === 1) {
          sel[code] = true;
        }
        return sel;
      }

      cartVo.forEach(({ code, product }) => {
        if (product.stock > 0 && product.status === 1) {
          if (
            selection[code] ||
            product.type === 8 ||
            product.type === 9 ||
            product.type === 13
          ) {
            sel[code] = true;
          }
        }
      });
      return sel;
    }, {});

    yield put(loadCartListCompletion(cartType, undefined, list));
    yield put(loadCartNumber(cartType));
    yield put(setStorageCartSelection(cartType, selection));
    if (needsPreCreate) {
      yield put(loadCartExtraInfo(cartType));
    }
    yield call(app.setStorage, storageKey, selection);
  });
}
export function* watchLoadCartNumber() {
  yield takeEvery('LOAD_CART_NUMBER', function*({ cartType }) {
    let fetchUrl = '/api/cart/number';
    if (cartType === 2) {
      fetchUrl = '/api/globalCart/number';
    }

    const options = {
      url: fetchUrl,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadCartNumberCompletion(cartType, result.error, result.data));
  });
}
export function* watchUpdateCartSelection() {
  yield takeEvery(
    ['UPDATE_CART_SELECTION', 'UPDATE_CART_UNSELECTION'],
    function*({ cartType }) {
      let storageKeyPrefix = 'NORMAL_CART_SELECTION';
      let stateKey = 'cart';
      if (cartType === 2) {
        storageKeyPrefix = 'OVERSEA_CART_SELECTION';
        stateKey = 'overseaCart';
      }

      const [own, selection] = yield select(state => [
        state.own.own,
        state.mall.cart[stateKey].selection,
      ]);
      const storageKey = `${storageKeyPrefix}_${own ? own.uid : ''}`;

      yield put(loadCartExtraInfo(cartType));
      yield call(app.setStorage, storageKey, selection);
    }
  );
}

export function* watchAddCart() {
  yield takeEvery('ADD_CART', function*({ addList, cartType }) {
    let fetchUrl = '/api/cart/add';
    let storageKeyPrefix = 'NORMAL_CART_SELECTION';
    let stateKey = 'cart';
    if (cartType === 2) {
      fetchUrl = '/api/globalCart/add';
      storageKeyPrefix = 'OVERSEA_CART_SELECTION';
      stateKey = 'overseaCart';
    }

    const options = {
      url: fetchUrl,
      method: 'POST',
      data: addList.map(item => ({
        code: item.code,
        number: item.number,
        sort: true,
      })),
    };
    const result = yield call(app.httpFetch, options);

    app.dispatch(
      addCartCompletion(cartType, result.error, result.data, addList)
    );

    if (!result.error) {
      const [own, selection] = yield select(state => [
        state.own.own,
        state.mall.cart[stateKey].selection,
      ]);
      const storageKey = `${storageKeyPrefix}_${own ? own.uid : ''}`;

      app.showTips('succ', '已加入购物袋～');
      let storageSelection = yield call(app.getStorage, storageKey);

      yield call(app.setStorage, storageKey, {
        ...storageSelection,
        ...selection,
      });
    }
  });
}

export function* watchAddCartDefaultGift() {
  yield takeEvery('ADD_CART_DEFAULT_GIFT', function*({ addList, cartType }) {
    let fetchUrl = '/api/cart/add';
    let storageKeyPrefix = 'NORMAL_CART_SELECTION';
    let stateKey = 'cart';
    if (cartType === 2) {
      fetchUrl = '/api/globalCart/add';
      storageKeyPrefix = 'OVERSEA_CART_SELECTION';
      stateKey = 'overseaCart';
    }

    const options = {
      url: fetchUrl,
      method: 'POST',
      data: addList.map(item => ({
        code: item.code,
        number: item.number,
        sort: true,
      })),
    };
    const result = yield call(app.httpFetch, options);

    app.dispatch(
      addCartDefaultGiftCompletion(cartType, result.error, result.data, addList)
    );

    if (!result.error) {
      const [own, selection] = yield select(state => [
        state.own.own,
        state.mall.cart[stateKey].selection,
      ]);
      const storageKey = `${storageKeyPrefix}_${own ? own.uid : ''}`;

      let storageSelection = yield call(app.getStorage, storageKey);

      yield call(app.setStorage, storageKey, {
        ...storageSelection,
        ...selection,
      });

      yield put(loadCartList({ needsPreCreate: true }));
    }
  });
}

export function* watchAddXgCart() {
  yield takeEvery('ADD_XG_CART', function*({ addList }) {
    const productId = addList[0].code;

    yield put(addCart(addList));
    const addResult = yield take('ADD_CART_COMPLETION');

    if (addResult.error) {
      yield put(addXgCartCompletion(productId, addResult.error));
      return;
    }

    const infoResult = yield call(app.httpFetch, {
      url: `/api/xg/product/${productId}/canBuyNum`,
    });
    yield put(
      addXgCartCompletion(productId, infoResult.error, infoResult.data)
    );
  });
}

export function* watchRemoveCart() {
  yield takeEvery('REMOVE_CART', function*({
    removeList,
    cartType,
    needRefreshCart,
  }) {
    let fetchUrl = '/api/cart/remove';
    let storageKeyPrefix = 'NORMAL_CART_SELECTION';
    let stateKey = 'cart';
    if (cartType === 2) {
      fetchUrl = '/api/globalCart/remove';
      storageKeyPrefix = 'OVERSEA_CART_SELECTION';
      stateKey = 'overseaCart';
    }

    const options = {
      url: fetchUrl,
      method: 'POST',
      data: removeList,
    };

    const result = yield call(app.httpFetch, options);

    let prevSelection = yield select(
      state => state.mall.cart[stateKey].selection
    );
    prevSelection = { ...prevSelection };
    yield put(
      removeCartCompletion(cartType, result.error, result.data, removeList)
    );

    if (!result.error) {
      const contained = removeList.some(({ code }) => {
        return prevSelection[code];
      });
      if (contained) {
        const [own, selection] = yield select(state => [
          state.own.own,
          cartType === 2
            ? state.mall.cart.overseaCart.selection
            : state.mall.cart.cart.selection,
        ]);
        const storageKey = `${storageKeyPrefix}_${own ? own.uid : ''}`;
        yield call(app.setStorage, storageKey, selection);
      }
      needRefreshCart && (yield put(loadCartList(contained, cartType)));
    }
  });
}

export function* watchUpdateCartItem() {
  yield takeEvery('UPDATE_CART_ITEM', function*({
    code,
    number,
    oldNumber,
    cartType,
  }) {
    let fetchUrl = '/api/cart/add';
    let stateKey = 'cart';
    if (cartType === 2) {
      fetchUrl = '/api/globalCart/add';
      stateKey = 'overseaCart';
    }

    const options = {
      url: fetchUrl,
      method: 'POST',
      data: [{ code, number: number - oldNumber, sort: false }],
    };
    const result = yield call(app.httpFetch, options);

    const realNumber = result.error ? oldNumber : number;
    yield put(
      updateCartItemCompletion(
        cartType,
        code,
        result.error,
        realNumber,
        result.data
      )
    );
    if (!result.error) {
      const selection = yield select(
        state => state.mall.cart[stateKey].selection
      );
      if (selection[code]) {
        yield put(loadCartExtraInfo(cartType));
      }
    }
  });
}

export function* watchLoadCartMergeProductList() {
  yield takeEvery('LOAD_CART_MERGE_PRODUCT_LIST', function*({ cartType }) {
    const { query } = yield select(
      state => state.mall.cart.cart.mergeProductMaster
    );

    let fetchUrl = '/api/product/index2';
    if (cartType === 2) {
      fetchUrl = '/api/product/indexGlobal2';
    }

    const options = {
      url: fetchUrl,
      data: {
        no: 0,
        size: 999,
        couponCode: query.couponCode || '',
        actId: query.actId || '',
        freePost: query.freePost || '',
      },
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadCartMergeProductListCompletion(cartType, result.error, result.data)
    );
  });
}

function* watchAddCartMerge() {
  yield takeEvery('ADD_CART_MERGE', function*({ addList, cartType }) {
    yield put(addCart(addList, cartType));
    const addResult = yield take('ADD_CART_COMPLETION');

    if (addResult.error) {
      yield put(addCartMergeCompletion(addResult.error, cartType));
      return;
    }

    yield put(addCartMergeCompletion(null, cartType));
    yield put(loadCartList(true, cartType));
  });
}

function* watchLoadCartActivityGiftList() {
  yield takeEvery('LOAD_CART_ACTIVITY_GIFT_LIST', function*({
    activityId,
    money,
  }) {
    const options = {
      url: `/api/product/activity/${activityId}/${money}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(
      loadCartActivityGiftListCompletion(
        activityId,
        result.error,
        (result.data && result.data.listData) || []
      )
    );
  });
}

function* watchPickCartActivityGift() {
  yield takeEvery('PICK_CART_ACTIVITY_GIFT', function*({
    activityId,
    pickList,
    initialList,
  }) {
    const removeList = initialList.filter(({ code }) => {
      return pickList.findIndex(item => item.code === code) === -1;
    });
    const addList = pickList.filter(({ code }) => {
      return initialList.findIndex(item => item.code === code) === -1;
    });

    if (removeList.length === 0 && addList.length === 0) {
      yield put(
        pickCartActivityGiftCompletion(activityId, new Error('所选商品无改变'))
      );
      return;
    }

    if (removeList.length > 0) {
      yield put(removeCart(removeList, undefined, false));
      const removeResult = yield take('REMOVE_CART_COMPLETION');
      if (removeResult.error) {
        yield put(
          pickCartActivityGiftCompletion(activityId, removeResult.error)
        );
        return;
      }
    }
    if (addList.length === 0) {
      yield put(pickCartActivityGiftCompletion(activityId, undefined));
      yield put(loadCartList(true));
      return;
    }

    yield put(addCart(addList));
    const addResult = yield take('ADD_CART_COMPLETION');
    yield put(pickCartActivityGiftCompletion(activityId, addResult.error));

    if (!addResult.error) {
      yield put(loadCartList(true));
    }
  });
}

function* watchLoadCartExtraInfo() {
  yield takeEvery('LOAD_CART_EXTRA_INFO', function*({
    cartType,
    cashId,
    giftList,
    recoverData,
    from,
  }) {
    let stateKey = 'cart';
    if (cartType === 2) {
      stateKey = 'overseaCart';
    }

    const products = yield select(state => state.mall.product.products);

    const cart = yield select(state => state.mall.cart[stateKey]);
    const { list, selection, cartItems } = cart;
    let selectedList = [];
    let orderType = cartType === 2 ? 6 : 0;

    if (cartType === 1) {
      selectedList = (list || []).reduce((sel, { cartCodes }) => {
        cartCodes.forEach(code => {
          if (selection[code]) {
            sel.push({
              code,
              number: cartItems[code].number,
              type: products[code].type,
              realPay: products[code].realPrice,
            });
          }
        });
        return sel;
      }, []);
    } else if (cartType === 2) {
      selectedList = (list || []).reduce((sel, code) => {
        if (selection[code]) {
          sel.push({
            code,
            number: cartItems[code].number,
            type: products[code].type,
            realPay: products[code].realPrice,
          });
        }

        return sel;
      }, []);
    }

    const orderSkuVos = selectedList.map(item => ({
      code: item.code,
      num: item.number,
    }));

    if (orderSkuVos.length <= 0 && giftList.length <= 0) {
      yield put(resetCartExtraInfo(cartType));
      yield put(
        loadCartExtraInfoCompletion(cartType, new Error('订单商品不能为空'))
      );
      return;
    }

    if (from !== 'gift') {
      if (giftList.length === 0) {
        if (cart.extraInfo && cart.extraInfo.giftList.length !== 0) {
          giftList = cart.extraInfo.giftList;
        }
      }
    }

    let url = '/api/order/preCreate';

    const options = {
      url,
      method: 'POST',
      data: {
        orderType,
        orderSkuVos,
        orderDiscountVo: {
          productCouponIds: giftList,
          cashCouponId: cashId || undefined,
        },
      },
    };
    const result = yield call(app.httpFetch, options);

    if (result.error) {
      const storageKeyPrefix =
        orderType === 6 ? 'OVERSEA_CART_SELECTION' : 'NORMAL_CART_SELECTION';

      const own = yield select(state => state.own.own);
      const prevSelectedList = cart.extraInfo.selectedList;
      const storageKey = `${storageKeyPrefix}_${own ? own.uid : ''}`;
      const selection = prevSelectedList.reduce((sel, { code }) => {
        sel[code] = true;
        return sel;
      }, {});

      yield put(
        loadCartExtraInfoCompletion(
          cartType,
          result.error,
          null,
          orderType,
          prevSelectedList
        )
      );
      yield call(app.setStorage, storageKey, selection);
      return;
    }

    yield put(
      loadCartExtraInfoCompletion(
        cartType,
        result.error,
        result.data,
        orderType,
        selectedList,
        giftList,
        recoverData
      )
    );
    if (result.data.removeSku && result.data.removeSku.length > 0) {
      const removeList = result.data.removeSku.map(code => {
        return {
          code,
          number: 1,
        };
      });
      yield put(removeCart(removeList));
    }
    if (result.data.addSku && result.data.addSku.length > 0) {
      const addList = result.data.addSku.map(code => {
        return {
          code,
          number: 1,
        };
      });
      yield put(addCartDefaultGift(addList));
    }
  });
}

export function* watchLoadCartShareInfo() {
  yield takeEvery('LOAD_CART_SHARE_INFO', function*({ list }) {
    const orderSkuVos = list.map(item => ({
      code: item.code,
      num: item.number,
    }));
    const options = {
      url: '/api/product/combination',
      method: 'POST',
      data: { orderSkuVos },
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadCartShareInfoCompletion(result.data, result.error));
  });
}

export function* watchLoadCartManJLevels() {
  yield takeLatest('LOAD_CART_MAN_J_LEVELS', function* () {
    const result = yield call(app.httpFetch, { url: '/api/mj/listMjInfo' });
    yield put(loadCartManJLevelsCompletion(result.error, result.data));
  })
}

export default function* cartSaga() {
  yield all([
    fork(watchLoadCartList),
    fork(watchLoadCartNumber),
    fork(watchUpdateCartSelection),
    fork(watchAddCart),
    fork(watchAddCartDefaultGift),
    fork(watchAddXgCart),
    fork(watchRemoveCart),
    fork(watchUpdateCartItem),
    fork(watchLoadCartMergeProductList),
    fork(watchAddCartMerge),
    fork(watchLoadCartActivityGiftList),
    fork(watchPickCartActivityGift),
    fork(watchLoadCartExtraInfo),
    fork(watchLoadCartShareInfo),
    fork(watchLoadCartManJLevels),
  ]);
}
